import { P } from '@farewill/ui'
import { useFormikContext } from 'formik'

import { getDateFromParts } from 'lib/formik/dates'

import { BIRTH, DEATH } from '../field-names'

const AgeAtDeath = () => {
  const { values } = useFormikContext()
  const dateOfBirth = getDateFromParts({ prefix: BIRTH, values })
  const dateOfDeath = getDateFromParts({ prefix: DEATH, values })

  if (!dateOfBirth || !dateOfDeath) return null

  const ageAtDeath = dateOfDeath.diff(dateOfBirth, 'years')
  return <P>Age at death: {ageAtDeath}</P>
}

export default AgeAtDeath
